import Crud from '../components/SignatureBatch/Crud'
import SignatureBatch from '../components/SignatureBatch/SignatureBatch'
import ManagementBatches from '../components/SignatureBatch/Management/Batches'
import ManagementSignatures from '../components/SignatureBatch/Management/Signatures'
import ManagementApi from '../components/SignatureBatch/Management/Api'
import View from '../components/SignatureBatch/View'


let routes = {
    path: '/signatureBatch',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/signatureBatches',
            name: 'Lote de Assinaturas',
            component: Crud
        },
        {
            path: '/signatureBatches/management/batches',
            name: 'Gerenciamento de Lotes',
            component: ManagementBatches
        },
        {
            path: '/signatureBatches/management/signatures',
            name: 'Gerenciamento de Assinaturas',
            component: ManagementSignatures
        },
        {
            path: '/signatureBatches/management/api',
            name: 'Gerenciamento de Assinaturas via API',
            component: ManagementApi
        },
        {
            path: '/SignatureBatch/:id?',
            name: 'Lote de Assinatura',
            component: SignatureBatch
        },
        {
            path: '/signatureBatches/view/:id?',
            name: 'Visualização de Lote de Assinatura',
            component: View
        },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/signatureBatch.js